<template>
  <div class="sidebar">

    <div class="logo">
      <div class="logo-wrapper relative"
        @click="handleLogoClick"
        :style="{ cursor: badgeStatus !== 'auth' ? 'pointer' : 'default' }">
        <img src="@/assets/newimages/login.png" />
        <div class="license-tag" :class="badgeClass">
          {{ badgeText }}
        </div>
      </div>
    </div>

    <div class="sideList">
      <div class="side-item" v-for="item in menu" :key="item.num" :class="item.isActive == true ? 'optionsItem-active' : ''" @click="chooseTab(item)">
        <img :src="item.activeImg" v-if="item.isActive == true" />
        <img :src="item.img" v-else />
        <div class="title">{{ item.name }}</div>
        <span v-if="item.num == 24 && unorder_count > 0" class="tasknum">{{ unorder_count > 99 ? '99+' : unorder_count }}</span>
      </div>

      <!-- 添加“模式”按钮 -->
      <div class="side-item mode-button" @click="changeModel">
        <van-icon name="home-o" size="0.50rem" color="#fff" class="mg-rt10 nav-icon" />
        <div class="title">模式</div>
      </div> 
    </div>

    <!-- 切换模式弹窗 -->
    <van-popup v-model="showModeSwitch" position="center" round closeable get-container="body">
      <div class="mode-switch-popup">
        <h3>{{ changeModelText }}</h3>
        <div class="input-group" v-if="managerMode == 1">
          <!-- <label for="managePassword">管理密码</label> -->
          <input type="password" id="managePassword" v-model="originPaw" placeholder="请输入管理密码" @keyup.enter="confirmChange" />
          <p><van-icon name="info" color="#666" size="0.36rem" class="mg-rt15" />默认管理密码为：123456</p>
          <div v-if="errorMsg" class="error-message">{{ errorMsg }}</div>
        </div>

        <!-- 门店模式切换功能 -->
        <div class="business-model-switch" v-if="managerMode == 0">
          <div class="model-item" v-for="(item, index) in businessModels" :key="index">
            <div class="model-name">{{ item.name }}</div>
            <div class="model-description">{{ item.description }}</div>
            <van-switch v-model="item.enabled" active-color="#FE724F" inactive-color="#CCCCCC" @change="handleModelChange(item)" />
          </div>
        </div>

        <!-- 添加经营模式切换功能 -->   
        <!-- <div class="confirmation-text" v-if="managerMode == 0">确认切换为经营模式？</div> -->
        <div class="button-group" v-if="managerMode == 1">
          <button @click="closeModal">取消</button>
          <button @click="confirmChange">确认</button>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="showLog" :style="{ height: '100%',width:'100%' }">
      <div class="logger">
        <!-- <p class="mg-bt20">
                    打印机连接：<span :class="{'success':discovered_copy,'fail':!discovered_copy}">{{discovered_copy}}</span>
                    正在打印：<span :class="{'success':printing,'fail':!printing}">{{printing}}</span>
                    打印队列准备：<span :class="{'success':canPrint,'fail':!canPrint}">{{canPrint?'ready':'not-ready'}}</span>
                    打印队列：<span>{{dcArray.length}}</span>
                </p> -->
        <table class="">
          <thead>
            <tr>
              <th>ID</th>
              <th>时间</th>
              <th>TYPE</th>
              <th>说明</th>
              <th>打印状态</th>
              <th style="width:17rem">内容</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(x) in log" :key="x.index">
              <td>{{x.id}} </td>
              <td>{{formatDate(x.time)}} </td>
              <td>{{x.case}} </td>
              <td>{{x.explain}}</td>
              <td :class="{'success':x.is_print,'fail':!x.is_print}">{{x.is_print}}</td>
              <td style="font-size:0.24rem">{{x.data}}</td>
            </tr>
          </tbody>
        </table>
        <!-- <div class="closeLOG2" @click="forcePrint">强制打印</div> -->
        <div class="closeLOG" @click="showLog = false">关闭</div>
      </div>
    </van-popup>

    <!-- <div class="onTop" v-if="$printer == 1 || $printer == 3" @click="showLog = true" v-drag>查看日志</div> -->

    <!-- <van-notice-bar
                class="global-notify-box"
                v-show="isShowNotify"
                mode="closeable"
                left-icon="volume-o"
                color="#000"
                background="#ffede9"
                @close="closeNotify"
            >
                {{notifyContent}}
            </van-notice-bar> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { _typeofEnv, checkPrintType, printTest, editTipsStatus, printTestReturnMenu, formatTime } from '../utils/util'
export default {
  name: "sidebar",
  props: {
    activeMenu: Number //当前显示为激活的菜单 在下面的menu中要使用的num
  },
  components: {},
  data() {
    return {
      allMenuList: [
        {
          num: 22,
          name: "开台",
          img: require("../assets/newimages/sidebar2-desk.png"),
          activeImg: require("../assets/newimages/sidebar2-desk.png"),
          isActive: false,
          jumpName: "deskNum"
        },
        {
          num: 29,
          name: "点餐",
          img: require("../assets/newimages/sidebar29-fastfood.png"),
          activeImg: require("../assets/newimages/sidebar29-fastfood.png"),
          isActive: false,
          jumpName: "fastfood"
        },
        {
          num: 24,
          name: "订单",
          img: require("../assets/newimages/sidebar4-order.png"),
          activeImg: require("../assets/newimages/sidebar4-order.png"),
          isActive: false,
          jumpName: "orderList"
        },
        {
          num: 25,
          name: "会员",
          img: require("../assets/newimages/sidebar14-member.png"),
          activeImg: require("../assets/newimages/sidebar14-member.png"),
          isActive: false,
          jumpName: "member"
        },
        {
          num: 28,
          name: "寄存",
          img: require("../assets/newimages/sidebar-check.png"),
          activeImg: require("../assets/newimages/sidebar-check.png"),
          isActive: false,
          jumpName: "check"
        },
        // 报表
        {
          num: 26,
          name: "报表",
          img: require("../assets/newimages/sidebar5-report.png"),
          activeImg: require("../assets/newimages/sidebar5-report.png"),
          isActive: false,
          jumpName: "revenue"
        },
        {
          num: 27,
          name: "设置",
          img: require("../assets/newimages/sidebar6-setting.png"),
          activeImg: require("../assets/newimages/sidebar6-setting.png"),
          isActive: false,
          jumpName: "settingNew"
        },
      ],
      showLog: false,
      controller: null,
      printContList: [], // 小程序订单的打印任务
      voiceList: [], // 语音播报
      isRequesting: false,
      // 添加业务模式数据
      businessModels: [
        { name: '开台', description: '开启后，收银台支持正餐开台模式，小程序支持扫码开台点餐。' },
        { name: '点餐', description: '开启后，收银台支持快餐点餐模式，小程序支持到店自取。' },
        { name: '寄存', description: '开启后，收银台支持寄存，客户可在小程序查询当前寄存物品。' },
        { name: '外卖', description: '开启后，小程序支持配送到家的自营外卖模式。' },
        { name: '结账', description: '开启后，扫码点餐为先付款后就餐模式，关闭时扫码点餐需到收银台结账。' }
      ],
      showModeSwitch: false,
      originPaw: '', // 管理密码输入框的值
      managerMode: 0, // 1: 管理模式, 0: 经营模式
      errorMsg: '', // 错误提示
    };
  },
  computed: {
    ...mapGetters({ log: "log", shop: 'shop', businessModel: 'businessModel' }),
    menu() {
      let menu_ = this.allMenuList;
      if (this.businessModel.open_tabel != 1) {
        menu_ = menu_.filter(e => e.num != 22);
      }
      if (this.businessModel.self_pickup != 1) {
        menu_ = menu_.filter(e => e.num != 29);
      }
      if (this.shop.user_model != 1) {
        menu_ = menu_.filter(e => e.num != 26);
      }
      if (this.businessModel.deposit != 1) {
        menu_ = menu_.filter(e => e.num != 28);
      }
      return menu_;
    },
    // 订单（未结订单）数量
    unorder_count() {
      return this.$store.state.unorderCount;
    },
    isShowNotify() {
      return this.$store.state.isShowNotify;
    },
    notifyContent() {
      return this.$store.state.notifyContent;
    },
    isApp() {
      return localStorage.nowDevice || '';
    },
    changeModelText() {
      return this.managerMode === 1 ? '切换至管理模式' : '门店模式';
    },
    badgeStatus() {
      const { is_free, device_bind, trial_end_time } = this.shop || {};
      if (is_free === undefined) return null;
      const hasBind = this._hasDeviceBind(device_bind);
      const isTrialValid = trial_end_time && new Date(trial_end_time) > new Date();
      if (Number(is_free) === 2 && hasBind) return 'auth';  // 付费 + pos已绑定 → 授权版
      if (isTrialValid) return 'trial';                      // trial未过期 → 试用版
      return 'free';                                         // 其他 → 免费版
    },
    badgeText() {
      return { auth: '授权版', trial: '试用版', free: '免费版' }[this.badgeStatus] || '';
    },
    badgeClass() {
      return `badge-${this.badgeStatus}`;
    },
    authNoticeText() {
      if (this.badgeStatus === 'trial') {
        const endTime = this.shop.trial_end_time;
        if (endTime) {
          const remaining = Math.ceil((new Date(endTime) - new Date()) / (1000 * 60 * 60 * 24));
          return `您当前处于试用版，距到期还有 ${remaining} 天，到期后将降为免费版（功能受限），请购买授权继续使用全部功能。`;
        }
        return '您当前处于试用版，请购买授权以继续使用全部功能。';
      }
      return '您当前处于免费版，菜品、会员、桌位数量上限为10个，请购买授权解锁全部功能。';
    },
  },
  methods: {
    handleLogoClick() {
      if (this.badgeStatus === 'free' || this.badgeStatus === 'trial') {
        this.$bus.$emit('openAuthBuyModal');  // 直接打开购买弹窗
      }
    },
    _hasDeviceBind(deviceBind) {
      if (!deviceBind) return false;
      if (Array.isArray(deviceBind)) return deviceBind.includes('pos');
      if (typeof deviceBind === 'string') {
        try {
          const parsed = JSON.parse(deviceBind);
          if (Array.isArray(parsed)) return parsed.includes('pos');
        } catch (e) {}
        return deviceBind.split(',').map(s => s.trim()).includes('pos');
      }
      return false;
    },
    closeNotify() {
      this.$store.commit('updateIsShowNotify', false);
    },
    formatDate(date) {
      var date = new Date(date);
      var YY = date.getFullYear();
      var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
      var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
      var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours());
      var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
      var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
      return `${YY}/${MM}/${DD} ${hh}:${mm}:${ss}`;
    },
    getStoreInfo() {
      console.log('getStoreInfo 123');
      this.$api.getShopInfo().then((res) => {
        if (res.code == 1) {
          // user_model:1，表示是店长模式 0，表示为普通模式
          // vip_level:0，表示只有大厅（退菜不用发送不提示） 1，有大厅和服务员（退菜不提示） 2，大厅服务员后厨都有（发送提示就按现在的逻辑判断）
          this.$store.dispatch("setShopInfo", res.data);
          localStorage.setItem('scale_type', res.data.scale_type || '');
          localStorage.setItem('box_type', res.data.box_type || '');

          // 根据 mini_eat_type 设置 businessModels 中 "结账" 项的 enabled 状态
          const miniEatType = res.data.mini_eat_type;
          const checkoutModel = this.businessModels.find(model => model.name === '结账');
          if (checkoutModel) {
            console.log('mini_eat_type:', miniEatType);
            checkoutModel.enabled = Number(miniEatType) === 1; // mini_eat_type 为 2 时 enabled 为 true，否则为 false
          }
        }
      });
    },
    //点击sidebar
    chooseTab(item) {
      let { allMenuList } = this;
      allMenuList.forEach(m => {
        m.isActive = false;
      });
      item.isActive = true;
      this.$emit("routerPush", [item.name, item.num, item.jumpName]);
    },
    // 获取待办数量
    async getTaskNum() {
      if (this.isRequesting) {
        return
      }
      this.isRequesting = true;
      let params = {
        printer_id: localStorage.printer_id || 0,
        device_mac: this.$store.state.deviceMac
      }
      this.$api.getDealCount(params).then(res => {
        if (res.code == 1) {
          this.isRequesting = false;
          this.$store.commit('setUnorderCount', res.data.unorder_count || 0);
          // 语音播报
          if (res.data.voice_set && res.data.voice_set.chash_tip == 1) {
            this.voiceList = res.data.voice_content || [];
            if (this.voiceList.length > 0) {
              for (let i = 0; i < this.voiceList.length; i++) {
                const element = this.voiceList[i];
                // print_purpose 0 點菜  1 退菜
                if (element.type == 2) {
                  // 您有新的外卖订单，请及时处理
                  this.$bus.$emit("beginVoice", {
                    type: 1,
                    path: '/voice/new_take_away.MP3'
                  });
                } else if (element.type == 3) {
                  // 您有新的自取订单，请及时处理
                  this.$bus.$emit("beginVoice", {
                    type: 1,
                    path: '/voice/new_self_pickup.MP3'
                  });
                } else if (element.type == 1) {
                  if (element.print_purpose == 1) { // 暂时不需要语音
                    // this.$bus.$emit("beginVoice", `您有退菜单`);
                  } else {
                    // 您有新的桌位订单，请及时处理
                    this.$bus.$emit("beginVoice", {
                      type: 1,
                      path: '/voice/new_open_tabel.MP3'
                    });
                  }
                }
              }
            }
          }

          // 打印任务
          this.printContList = res.data.print_content || [];
          console.log("%c Line:263 🥤 this.printContList", "color:#3f7cff", this.printContList);
          if (this.printContList.length > 0) {
            for (let i = 0; i < this.printContList.length; i++) {
              const element = this.printContList[i];
              if (res.data.voice_set && res.data.voice_set.order_tip == 1) {
                this.takeFoodVoice(element);
              }
              console.log('element', element);
              if (element.print_type == 3) { // 退菜单
                element['desk_num_name'] = element.desk_num || '';
                element['price'] = element.food_price;
                if (element.food_type == 3) {
                  let spec_json = {};
                  if (typeof element.spec_json == 'string') {
                    spec_json = JSON.parse(element.spec_json);
                  } else if (typeof element.spec_json == 'object') {
                    spec_json = element.spec_json || {};
                  }
                  const cus_setmeal_list = spec_json.setmeal_list || [];
                  element['c_setmeal_list'] = cus_setmeal_list;
                }
                // 前台打印退菜单
                if (element.print_menu == 1) {
                  let result4 = printTestReturnMenu(
                    element,
                    element,
                    element.return_num,
                    element.return_num + (element.unit_name || '份'),
                    27,
                    element.return_content,
                  );
                  if (element.print_list && element.print_list.length) {
                    this.$bus.$emit("QtReturnMenuPrint", this.handleMultiplePrint(result4, element.print_list));
                  }
                }
                if (element.print_return_menu == 1) {
                  // 后厨打印退菜单
                  if (element.food_type == 3) {
                    if (element.spec_json) {
                      const cus_setmeal_list = element.spec_json.setmeal_list || [];
                      for (let m = 0; m < cus_setmeal_list.length; m++) {
                        const food = cus_setmeal_list[m];
                        food['food_name'] = food.name;
                        food['spec_attr_name'] = food.attr;
                        food['return_time'] = element.return_time || '';
                        if ((food.ip && food.ip != "") || (food.cloud_sn && food.cloud_sn != '')) {
                          let result3 = printTestReturnMenu(
                            element,
                            food,
                            food.num * element.return_num,
                            (food.num * element.return_num) + (element.unit_name || '份'),
                            18,
                            element.return_content,
                          );
                          console.log('result3', result3);
                          // console.log('退擦弹');
                          this.$bus.$emit("returnMenuPrint", result3);
                        }
                      }
                    }
                  } else {
                    if ((element.ip && element.ip != "") || (element.cloud_sn && element.cloud_sn != '')) {
                      let result3 = printTestReturnMenu(
                        element,
                        element,
                        element.return_num,
                        element.return_num + (element.unit_name || '份'),
                        18,
                        element.return_content,
                      );
                      console.log('result3', result3);
                      // console.log('退擦弹');
                      this.$bus.$emit("returnMenuPrint", result3);
                    }
                  }
                }
              } else if (element.print_type == 1 || element.print_type == 2 || element.print_type == 4 || element.print_type == 6) {
                // setTimeout(() => {
                editTipsStatus(2, element.order_id);
                // }, 1200);
                // 前台是否打印点菜单
                if ((element.print_type == 1) && element.print_menu == 1) {
                  if (element.is_addFood == 1) { // 服务员过来的加菜单
                    const edata = {
                      data: element
                    }
                    const printData = {
                      type: 7,
                      data: edata,
                    };
                    let result1 = printTest(printData, 22);
                    if (element.print_front_menu && element.print_front_menu.length) {
                      this.$bus.$emit("addFromHall1", this.handleMultiplePrint(result1, element.print_front_menu));
                    }
                  } else {
                    const edata = {
                      data: element
                    }
                    const printData = {
                      type: 7,
                      data: edata,
                    };
                    let result1 = printTest(printData, 2);
                    if (element.print_front_menu && element.print_front_menu.length) {
                      this.$bus.$emit("addFromHall1", this.handleMultiplePrint(result1, element.print_front_menu));
                    }
                  }
                }

                // 前台是否打印结账单
                if ((element.print_type == 2 || element.print_type == 4 || element.print_type == 6) && element.print_receipt == 1) {
                  const edata = {
                    data: element
                  }
                  const printData = {
                    type: 7,
                    data: edata,
                  };
                  let result1 = printTest(printData, 4);
                  if (element.print_front_menu && element.print_front_menu.length) {
                    this.$bus.$emit("addFromHall2", this.handleMultiplePrint(result1, element.print_front_menu));
                  }
                }
                // 客单
                // const edata = {
                //     data: element
                // }
                // const printData = {
                //     type: 27,
                //     data: edata,
                // };
                // let result6 = printTest(printData, 23);
                // this.$bus.$emit("guestPrinting", result6);

                // 打印前台做菜单
                if (element.print_food == 1) {
                  const edata = {
                    data: element
                  }
                  const printData_ = {
                    type: 23,
                    data: edata
                  }
                  let result4 = printTest(printData_, 19);
                  if (element.print_front_menu && element.print_front_menu.length) {
                    this.$bus.$emit("qtMenuPrint", this.handleMultiplePrint(result4, element.print_front_menu));
                  }
                }

                // 后厨是否打印做菜单
                if (element.hc_print_food == 1) {
                  const edata = {
                    data: element
                  }
                  const printData_ = {
                    type: 21,
                    data: edata
                  }
                  let result3 = printTest(printData_, 3);
                  // console.log('```````', result3);
                  this.$bus.$emit('menuPrint', result3);
                }

                // 后厨是否打印传菜单
                if (element.print_pass_menu == 1) {
                  // const edata = {
                  //     data: element
                  // }
                  // const printData_1 = {
                  //     type: 24,
                  //     data: edata
                  // }
                  // let result5 = printTest(printData_1, 20);
                  // this.$bus.$emit('passThoughtPrint', result5);
                }

                // 标签制作单
                if (element.print_tag_menu == 1) {
                  // if (element.down_time && element.down_time != '') {
                  //     element['date'] = element.down_time.split(' ')[0];
                  //     element['time'] = element.down_time.split(' ')[1];
                  // }
                  const edata1 = {
                    data: element
                  }
                  const printData1 = {
                    type: 25,
                    data: edata1,
                  };
                  let result6 = printTest(printData1, 25);
                  this.$bus.$emit('qtLabelPrint', result6);
                }
              } else if (element.print_type == 5) {
                console.log('[补打数据]', element); // 查看 dishList 是否存在
                // 服务员补打 print_purpose: 2=结账单补打, 3=点菜单补打
                editTipsStatus(2, element.order_id);
                const edata = { data: element };
                if (element.print_purpose == 2) {
                  // 结账单补打
                  const printData = { type: 7, data: edata, isReprint: 1 };
                  let result1 = printTest(printData, 4);
                  if (element.print_front_menu && element.print_front_menu.length) {
                    this.$bus.$emit("addFromHall2", this.handleMultiplePrint(result1, element.print_front_menu));
                  }
                } else if (element.print_purpose == 3) {
                  // 点菜单补打
                  const printData = { type: 7, data: edata, isReprint: 1 };
                  let result1 = printTest(printData, 2);
                  if (element.print_front_menu && element.print_front_menu.length) {
                    this.$bus.$emit("addFromHall1", this.handleMultiplePrint(result1, element.print_front_menu));
                  }
                }
              }  
            }
          }
        } else {
          this.isRequesting = false;
        }
      }).catch(err => {
        this.isRequesting = false;
      })
    },
    // win打印轮询
    getPrintOrderWin(params) {
      return new Promise((resolve, reject) => {
        this.$api.getPrintOrderWin(params).then(res => {
          if (res.code == 1) {
            // 打印任务
            this.printContList = res.data.print_content || [];
            console.log("%c Line:263 🥤 this.printContList", "color:#3f7cff", this.printContList);
            if (this.printContList.length > 0) {
              for (let i = 0; i < this.printContList.length; i++) {
                const element = this.printContList[i];
                if (res.data.voice_set && res.data.voice_set.order_tip == 1) {
                  this.takeFoodVoice(element);
                }
                console.log('element', element);
                if (element.print_type == 3) { // 退菜单
                  element['desk_num_name'] = element.desk_num || '';
                  element['price'] = element.food_price;
                  if (element.food_type == 3) {
                    let spec_json = {};
                    if (typeof element.spec_json == 'string') {
                      spec_json = JSON.parse(element.spec_json);
                    } else if (typeof element.spec_json == 'object') {
                      spec_json = element.spec_json || {};
                    }
                    const cus_setmeal_list = spec_json.setmeal_list || [];
                    element['c_setmeal_list'] = cus_setmeal_list;
                  }
                  // 前台打印退菜单
                  if (element.print_menu == 1) {
                    let result4 = printTestReturnMenu(
                      element,
                      element,
                      element.return_num,
                      element.return_num + (element.unit_name || '份'),
                      27,
                      element.return_content,
                    );
                    if (element.print_list && element.print_list.length) {
                      this.$bus.$emit("QtReturnMenuPrint", this.handleMultiplePrint(result4, element.print_list));
                    }
                  }
                  if (element.print_return_menu == 1) {
                    // 后厨打印退菜单
                    if (element.food_type == 3) {
                      if (element.spec_json) {
                        const cus_setmeal_list = element.spec_json.setmeal_list || [];
                        for (let m = 0; m < cus_setmeal_list.length; m++) {
                          const food = cus_setmeal_list[m];
                          food['food_name'] = food.name;
                          food['spec_attr_name'] = food.attr;
                          food['return_time'] = element.return_time || '';
                          if ((food.ip && food.ip != "") || (food.cloud_sn && food.cloud_sn != '')) {
                            let result3 = printTestReturnMenu(
                              element,
                              food,
                              food.num * element.return_num,
                              (food.num * element.return_num) + (element.unit_name || '份'),
                              18,
                              element.return_content,
                            );
                            console.log('result3', result3);
                            // console.log('退擦弹');
                            this.$bus.$emit("returnMenuPrint", result3);
                          }
                        }
                      }
                    } else {
                      if ((element.ip && element.ip != "") || (element.cloud_sn && element.cloud_sn != '')) {
                        let result3 = printTestReturnMenu(
                          element,
                          element,
                          element.return_num,
                          element.return_num + (element.unit_name || '份'),
                          18,
                          element.return_content,
                        );
                        console.log('result3', result3);
                        // console.log('退擦弹');
                        this.$bus.$emit("returnMenuPrint", result3);
                      }
                    }
                  }
                } else if (element.print_type == 1 || element.print_type == 2) {
                  // setTimeout(() => {
                  editTipsStatus(2, element.order_id);
                  // }, 1200);
                  // 前台是否打印点菜单
                  if (element.print_type == 1 && element.print_menu == 1) {
                    if (element.is_addFood == 1) { // 服务员过来的加菜单
                      const edata = {
                        data: element
                      }
                      const printData = {
                        type: 7,
                        data: edata,
                      };
                      let result1 = printTest(printData, 22);
                      if (element.print_front_menu && element.print_front_menu.length) {
                        this.$bus.$emit("addFromHall1", this.handleMultiplePrint(result1, element.print_front_menu));
                      }
                    } else {
                      const edata = {
                        data: element
                      }
                      const printData = {
                        type: 7,
                        data: edata,
                      };
                      let result1 = printTest(printData, 2);
                      if (element.print_front_menu && element.print_front_menu.length) {
                        this.$bus.$emit("addFromHall1", this.handleMultiplePrint(result1, element.print_front_menu));
                      }
                    }
                  }

                  // 前台是否打印结账单
                  if (element.print_type == 2 && element.print_receipt == 1) {
                    const edata = {
                      data: element
                    }
                    const printData = {
                      type: 7,
                      data: edata,
                    };
                    let result1 = printTest(printData, 4);
                    if (element.print_front_menu && element.print_front_menu.length) {
                      this.$bus.$emit("addFromHall2", this.handleMultiplePrint(result1, element.print_front_menu));
                    }
                  }
                  // 客单
                  // const edata = {
                  //     data: element
                  // }
                  // const printData = {
                  //     type: 27,
                  //     data: edata,
                  // };
                  // let result6 = printTest(printData, 23);
                  // this.$bus.$emit("guestPrinting", result6);

                  // 打印前台做菜单
                  if (element.print_food == 1) {
                    const edata = {
                      data: element
                    }
                    const printData_ = {
                      type: 23,
                      data: edata
                    }
                    let result4 = printTest(printData_, 19);
                    if (element.print_front_menu && element.print_front_menu.length) {
                      this.$bus.$emit("qtMenuPrint", this.handleMultiplePrint(result4, element.print_front_menu));
                    }
                  }

                  // 后厨是否打印做菜单
                  if (element.hc_print_food == 1) {
                    const edata = {
                      data: element
                    }
                    const printData_ = {
                      type: 21,
                      data: edata
                    }
                    let result3 = printTest(printData_, 3);
                    // console.log('```````', result3);
                    this.$bus.$emit('menuPrint', result3);
                  }

                  // 后厨是否打印传菜单
                  if (element.print_pass_menu == 1) {
                    // const edata = {
                    //     data: element
                    // }
                    // const printData_1 = {
                    //     type: 24,
                    //     data: edata
                    // }
                    // let result5 = printTest(printData_1, 20);
                    // this.$bus.$emit('passThoughtPrint', result5);
                  }

                  // 标签制作单
                  if (element.print_tag_menu == 1) {
                    // if (element.down_time && element.down_time != '') {
                    //     element['date'] = element.down_time.split(' ')[0];
                    //     element['time'] = element.down_time.split(' ')[1];
                    // }
                    const edata1 = {
                      data: element
                    }
                    const printData1 = {
                      type: 25,
                      data: edata1,
                    };
                    let result6 = printTest(printData1, 25);
                    this.$bus.$emit('qtLabelPrint', result6);
                  }
                }
              }
            }
          }
          resolve()
        }).catch(err => {
          reject()
        })
      });
    },
    // win未读订单和语音轮询
    getVoiceCountWin(params) {
      return new Promise((resolve, reject) => {
        this.$api.getVoiceCountWin(params).then(res => {
          if (res.code == 1) {
            // 未读订单数量
            this.$store.commit('setUnorderCount', res.data.unorder_count || 0);
            // 语音播报
            if (res.data.voice_set && res.data.voice_set.chash_tip == 1) {
              this.voiceList = res.data.voice_content || [];
              if (this.voiceList.length > 0) {
                for (let i = 0; i < this.voiceList.length; i++) {
                  const element = this.voiceList[i];
                  // print_purpose 0 點菜  1 退菜
                  if (element.type == 2) {
                    // 您有新的外卖订单，请及时处理
                    this.$bus.$emit("beginVoice", {
                      type: 1,
                      path: '/voice/new_take_away.MP3'
                    });
                  } else if (element.type == 3) {
                    // 您有新的自取订单，请及时处理
                    this.$bus.$emit("beginVoice", {
                      type: 1,
                      path: '/voice/new_self_pickup.MP3'
                    });
                  } else if (element.type == 1) {
                    if (element.print_purpose == 1) { // 暂时不需要语音
                      // this.$bus.$emit("beginVoice", `您有退菜单`);
                    } else {
                      // 您有新的桌位订单，请及时处理
                      this.$bus.$emit("beginVoice", {
                        type: 1,
                        path: '/voice/new_open_tabel.MP3'
                      });
                    }
                  }
                }
              }
            }
          }
          resolve()
        }).catch(err => {
          reject()
        })
      });
    },
    // 处理多个打印数据
    handleMultiplePrint(result, menu) {
      console.log("%c Line:468 🍪 result, menu", "color:#6ec1c2", result, menu);
      let ips = [];
      let sizes = [];
      let printTypes = [];
      menu.forEach(item => {
        ips.push(item.ip);
        sizes.push(item.size);
        printTypes.push(item.printer_type);
      })
      result.ips = ips;
      result.sizes = sizes;
      result.printTypes = printTypes;
      return result;
    },
    // 自取单自动完成时进行播报
    takeFoodVoice(element) {
      // 自取单自动完成时进行播报
      if (element.meal_type == 2 && element.order_type_index == 3 && this.shop.self_pick_auto_finish == 1) {
        this.$bus.$emit("beginVoice", `${element.pick_order_num}号订单已经出餐，请到前台取餐`);
      }
    },
    // 取消切换
    cancelModeSwitch() {
      this.showModeSwitch = false;
      this.originPaw = '';
      this.errorMsg = '';
    },
    // 确认切换
    async confirmChange() {
      if (this.managerMode === 1 && !this.originPaw) {
        this.errorMsg = '管理密码不能为空';
        return;
      }
      
      const data = new FormData();
      data.append("type", this.managerMode);
      if (this.managerMode === 1) {
        data.append("paw", this.originPaw);
      }
      
      try {
        const res = await this.$api.changeModel(data);
        if (res.code === 1) {
          this.$toast(res.msg || "操作成功");
          // 不关闭弹窗，直接更新状态
          this.getStoreInfo();
          
          if (this.managerMode === 1) {
            // 如果是经营模式切换管理模式成功
            this.managerMode = 0; // 设置为管理模式
            this.originPaw = ''; // 清空密码
            this.errorMsg = ''; // 清空错误信息
          } else {
            // 如果是管理模式切换经营模式成功
            this.managerMode = 1; // 设置为经营模式
          }
        } else {
          this.errorMsg = res.msg || "操作失败";
        }
      } catch (err) {
        this.errorMsg = "网络异常，请重试";
      }
    },
    closeModal() {
      this.showModeSwitch = false;
      this.originPaw = '';
      this.errorMsg = '';
    },    
    // 获取门店信息（用于更新当前用户模式）
    // getStoreInfo() {
    //   this.$api.getShopInfo().then(res => {
    //     if (res.code === 1) {
    //       this.$store.dispatch("setShopInfo", res.data);


    //     }
    //   });
    // },
    async handleModelChange(item) {
        // 使用常量定义类型
        const MODEL_TYPES = {
            '开台': 1,
            '外卖': 2,
            '点餐': 3,
            '寄存': 4,
            '结账': 5
        };
    
        const type = MODEL_TYPES[item.name];
        if (!type) return;
    
        // 结账特殊处理
        if (type === 5) {
            try {
                const payDate = new FormData();
                payDate.append('mini_eat_type', item.enabled ? 1 : 2);        //  '1': '先付款后就餐', '2': '线下付款'
                const res = await this.$api.editShopConfig(payDate);
                
                if (res.code === 1) {
                    this.$toast("结算方式修改成功");
                    this.getStoreInfo();
                } else {
                    this.handleError(item, res.msg || "修改失败");
                }
            } catch (err) {
                this.handleError(item, "网络异常，请稍后重试");
            }
            return;
        }
    
        try {
            const formData = new FormData();
            formData.append('type', type);
            formData.append('status', item.enabled ? 1 : 0);
            const result = await this.$api.editBusinessModel(formData);
    
            if (result.code !== 1) {
                this.handleError(item, result.msg || "操作失败");
                return;
            }
    
            this.$toast("操作成功");
            await this.$store.dispatch("getShopBusinessModel");
            
        } catch (error) {
            this.handleError(item, "网络异常，请稍后重试");
            this.$store.dispatch("getShopBusinessModel");
        }
    },
    
    // 提取公共错误处理方法
    handleError(item, message) {
        item.enabled = !item.enabled;
        this.$toast(message);
    },
    async resetBusinessModels() {
      try {
        const res = await this.$api.getBusinessModel();
        if (res.code === 1) {
          const data = res.data;
          console.log("haidaozy data:",data);
          console.log("haidaozy this.minPayType:",this.minPayType);
          // 将返回值转换为数字类型
          const openTabel = Number(data.open_tabel);
          const takeAway = Number(data.take_away);
          const selfPickup = Number(data.self_pickup);
          const deposit = Number(data.deposit);
          const miniPay = Number(this.minPayType);

          // 根据转换后的数值更新 businessModels 状态
          this.businessModels.forEach(model => {
            switch (model.name) {
              case '开台':
                model.enabled = openTabel === 1;
                break;
              case '外卖':
                model.enabled = takeAway === 1;
                break;
              case '点餐':
                model.enabled = selfPickup === 1;
                break;
              case '寄存':
                model.enabled = deposit === 1;
                break;
              case '结账':
                // 结账特殊处理，根据 mini_eat_type 判断
                model.enabled = miniPay === 1;
                break;
              default:
                break;
            }
          });
        }
      } catch (error) {
        console.error('Failed to reset business models:', error);
      }
    },
    // 点击按钮时判断当前用户模式
    changeModel() {
      this.errorMsg = '';
      if (this.shop.user_model === 1) {
        this.managerMode = 0; // 切换至经营模式，无需密码
      } else {
        this.managerMode = 1; // 切换至管理模式，需要密码
      }
      this.showModeSwitch = true;
      // 给各个切换按钮赋值
      this.getStoreInfo();
      // 如果是管理模式，重置业务模式状态
      if (this.managerMode === 0) {
        this.resetBusinessModels();
      }
    }
  },
  async mounted() {
    this.getStoreInfo();
    // 如果是管理模式，重置业务模式状态
    if (this.managerMode === 0) {
      this.resetBusinessModels();
    }
    try {
      this.allMenuList.forEach(element => {
        if (element.num == this.activeMenu) {
          element.isActive = true;
        } else {
          element.isActive = false;
        }
      });
    } catch (e) {
      // //console.log(e);
    }
  },
  created() {
    this.isRequesting = false;
    this.getTaskNum();
    clearInterval(this.controller);
    this.controller = null;
    this.controller = setInterval(async () => {
      this.getTaskNum();
    }, 5000)
  },
  activated() {
    this.getStoreInfo();
  },
  beforeDestroy() {
    clearInterval(this.controller);
  },
  watch: {
    activeMenu: {
      handler() {
        this.allMenuList.forEach(element => {
          if (element.num == this.activeMenu) {
            element.isActive = true;
          } else {
            element.isActive = false;
          }
        });
        // this.$store.dispatch("getShopBusinessModel");
      },
      deep: true,
      immediate: true,
    },
  }
};
</script>

<style lang="less" scoped>
.global-notify-box {
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  right: 0;
  z-index: 300;
  font-size: 0.4rem;
  height: 0.85rem;
  /deep/.van-icon {
    font-size: 0.4rem;
  }
  /deep/.van-notice-bar__left-icon {
    margin-right: 0.2rem;
  }
  /deep/.van-notice-bar__right-icon {
    margin-left: 0.2rem;
  }
}
@color: #1ccfcf;
.mode-box {
  position: fixed;
  top: 0.35rem;
  right: 10px;
  font-size: 0.3rem;
  background: @color;
  color: #fff;
  padding: 0.2rem;
  z-index: 20000;
}
.disconnected {
  -webkit-filter: grayscale(100%); /* Chrome, Safari, Opera */
  filter: grayscale(100%);
}

.sidebar {
  height: 100%;
  width: 1.7rem;
  position: absolute;
  left: 0;
  top: 0;
  background: #333333;
  overflow-x: hidden;
  overflow-y: scroll;
  z-index: 10;
  display: flex;
  flex-direction: column;

  .logo {
    height: 1.3rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.46rem;
    font-weight: bold;
    flex-direction: column;

    .logo-wrapper {
      position: relative;
      display: inline-block;
    }

    img {
      width: 0.8rem;
      height: 0.8rem;
      border-radius: 10px;
      display: block;
    }

    .license-tag {
      position: absolute;
      top: -0.08rem;
      right: -0.30rem;
      padding: 0.02rem 0.12rem;
      border-radius: 0.08rem;
      font-size: 0.18rem;
      font-weight: bold;
      line-height: 1.3;
      transform: scale(0.9);
      z-index: 2;
      box-shadow: 0 0.02rem 0.04rem rgba(0, 0, 0, 0.2);
    }

    .badge-auth {
      background: linear-gradient(135deg, #FFD700 0%, #FF8C00 100%);
      color: #fff;
    }
    .badge-trial {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: #fff;
    }
    .badge-free {
      background: #999999;
      color: #fff;
    }
  }
  .connectedstatus {
    width: 0.7rem;
    height: 0.7rem;
    right: -0.5rem;
    bottom: 0;
  }

  .sideList {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: auto;

    .side-item {
      text-align: center;
      font-size: 0.3rem;
      font-weight: 600;
      color: #fff;
      position: relative;
      height: 1.57rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      img {
        width: 0.45rem;
        height: 0.45rem;
      }

      .title {
        margin-top: 0.15rem;
      }

      .tasknum {
        position: absolute;
        background: #ff2a2a;
        padding: 0.05rem 0.1rem;
        border-radius: 50%;
        top: 0.25rem;
        right: 20%;
        color: #fff;
        font-size: 0.34rem;
      }
    }

    .mode-button {
      margin-top: auto;
      background: #333 !important;

      .nav-icon{
        margin: 0 auto;
      }
    }    

    .optionsItem-active {
      background: #fe724f;
    }
  }
}
.logger tr {
  text-align: left;
}
.success {
  color: green;
}
.fail {
  color: red;
}

.mode-button {
  background: #fe724f !important;
}
.mode-switch-popup {
  padding: 1rem;
  text-align: center;
  max-width: 25rem;
  font-size: 0.875rem;

  h3 {
    margin-bottom: 0.6rem;
    font-size: 0.6rem;
  }

  .input-group {
    margin-bottom: 0.5rem;

    label {
      display: block;
      margin-bottom: 0.4rem;
      font-size: 0.5rem;
    }

    input {
      width: 100%;
      padding: 0.3rem;
      border: 0.03rem solid #ccc;
      border-radius: 0.15rem;
      font-size: 0.35rem;
    }

    p {
      margin-top: 0.3125rem;
      font-size: 0.35rem;
      color: #666;
    }

    .error-message {
      margin-top: 0.625rem;
      color: red;
      font-size: 0.50rem;
    }
  }

  .confirmation-text {
    margin-bottom: 1.25rem;
    font-size: 0.8rem;
  }

  .business-model-switch {
    margin: 0.625rem 0;

    .model-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0.625rem 0;
      border-bottom: 0.03rem solid #eee;

      .model-name {
        font-size: 0.5rem;
        width: 2rem;
        color: #333;
        text-align: left;
        flex: 10%;
      }

      .model-description {
        font-size: 0.40rem;
        color: #666;
        text-align: left;
        margin-right: 0.4rem;
        flex: 70%;
      }
    }

    .model-item:last-child {
      border-bottom: none;
    }
  }

  .button-group {
    display: flex;
    justify-content: space-around;

    button {
      margin: 0.2rem 0.3rem;
      padding: 0.3rem 2rem;
      border: none;
      border-radius: 0.25rem;
      cursor: pointer;
      font-size: 0.4rem;

      &:first-child {
        background-color: #ccc;
      }

      &:last-child {
        background-color: #fe724f;
        color: #fff;
      }
    }
  }
}

.auth-notice-popup {
  width: 8rem;
  padding: 0.5rem 0.6rem 0.5rem;
  box-sizing: border-box;

  .auth-notice-title {
    font-size: 0.46rem;
    font-weight: bold;
    color: #333;
    text-align: center;
    padding-bottom: 0.28rem;
    margin-bottom: 0.28rem;
    border-bottom: 1px solid #f0f0f0;
  }

  .auth-notice-content {
    font-size: 0.36rem;
    color: #555;
    line-height: 1.8;
    margin-bottom: 0.4rem;
  }

  .auth-notice-buttons {
    display: flex;
    gap: 0.3rem;

    button {
      flex: 1;
      height: 0.88rem;
      border-radius: 0.44rem;
      border: none;
      font-size: 0.36rem;
      cursor: pointer;
    }
  }

  .auth-btn-cancel { background: #f0f0f0; color: #666; }
  .auth-btn-buy { background: #fe724f; color: #fff; }
}

</style>



// WEBPACK FOOTER //
// src/components/sidebar.vue